import Auth from '../../modules/Authentication'
import { apiUrl } from '../../variables/index'
import { handleErrors, handleResponse } from '../../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class ReportsApi {
  constructor() {
    this.auth = new Auth()
  }

  invoices = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}reports/`, { headers }).then(handleErrors).then(handleResponse)
  }
}
